// Banka Hesapları tablosunun sütunları ve formun alanları. Alan adları
// BankAccount belgelerindeki adlardır; metinler: bankAccounts.fields.<key>.

export const FORM_FIELDS = ['firma', 'sube', 'hesapNo', 'dosyaAciklama', 'odemeKesinti', 'odemeTuru', 'odemeAciklama', 'odemeDonemi', 'durum'];

export const EMPTY_FORM = Object.fromEntries(FORM_FIELDS.map((key) => [key, '']));

export const ACCOUNT_COLUMNS = {
  firma: { type: 'text', width: 220 },
  hesapNo: { type: 'text', width: 280 },
  sube: { type: 'text', width: 180 },
  durum: { type: 'text', width: 140 },
  odemeKesinti: { type: 'text', width: 160 },
  odemeTuru: { type: 'text', width: 170 },
  odemeDonemi: { type: 'text', width: 160 },
  dosyaAciklama: { type: 'text', width: 220 },
  odemeAciklama: { type: 'text', width: 240 },
};

export const COLUMN_KEYS = Object.keys(ACCOUNT_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['firma'];

// Durum serbest metin; rengi ve hızlı filtresi içeriğinden çıkarılır (eski
// sayfanın renk kuralı; "inaktif" artık yeşil görünmez)
export const STATUS_GROUPS = ['active', 'passive', 'pending', 'other'];
export const ALL_GROUPS = 'all';

export const statusGroupOf = (status) => {
  const value = String(status || '').toLocaleLowerCase('tr-TR');
  if (value.includes('pasif') || value.includes('kapalı') || value.includes('inaktif')) return 'passive';
  if (value.includes('aktif') || value.includes('açık')) return 'active';
  if (value.includes('bekle')) return 'pending';
  return 'other';
};

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
